function fallbackCopyTextToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
}

async function copyTextToClipboard(text: string | Promise<string>): Promise<void> {
    if (!navigator.clipboard && typeof text === 'string') {
        console.error('Буфер обмена не поддерживается в этом браузере.');
        fallbackCopyTextToClipboard(text);
        return;
    }

    try {
        await navigator.clipboard.write([
            new ClipboardItem({
                'text/plain': text,
            }),
        ]);
    } catch (error) {
        throw new Error('Ошибка при копировании текста:', error);
    }
}

export default copyTextToClipboard;
